export const ZCurrenciesData: Array<{
  value: string;
  label: string;
  symbol: string;
}> = [
  { value: "Bitcoin", label: "Bitcoin", symbol: "฿" },
  { value: "Ethereum", label: "Ethereum", symbol: "Ξ" },
  { value: "USDT", label: "USDT", symbol: "USDT" },
  { value: "USDC", label: "USDC", symbol: "USDC" },
  { value: "AFN", label: "Afghan afghani", symbol: "؋" },
  { value: "ALL", label: "Albanian lek", symbol: "L" },
  { value: "DZD", label: "Algerian dinar", symbol: "د.ج" },
  { value: "AOA", label: "Angolan kwanza", symbol: "Kz" },
  { value: "ARS", label: "Argentine peso", symbol: "$" },
  { value: "AMD", label: "Armenian dram", symbol: "֏" },
  { value: "AWG", label: "Aruban florin", symbol: "ƒ" },
  { value: "AUD", label: "Australian dollar", symbol: "$" },
  { value: "AZN", label: "Azerbaijani manat", symbol: "₼" },
  { value: "BHD", label: "Bahraini dinar", symbol: ".د.ب" },
  { value: "BSD", label: "Bahamian dollar", symbol: "$" },
  { value: "BDT", label: "Bangladeshi taka", symbol: "৳" },
  { value: "BBD", label: "Barbadian dollar", symbol: "$" },
  { value: "BYN", label: "Belarusian ruble", symbol: "Br" },
  { value: "BZD", label: "Belize dollar", symbol: "BZ$" },
  { value: "BMD", label: "Bermudian dollar", symbol: "$" },
  { value: "BTN", label: "Bhutanese ngultrum", symbol: "Nu." },
  { value: "BOB", label: "Bolivian boliviano", symbol: "Bs." },
  {
    value: "BAM",
    label: "Bosnia and Herzegovina convertible mark",
    symbol: "KM",
  },
  { value: "BWP", label: "Botswana pula", symbol: "P" },
  { value: "BRL", label: "Brazilian real", symbol: "R$" },
  { value: "GBP", label: "British pound", symbol: "£" },
  { value: "BND", label: "Brunei dollar", symbol: "$" },
  { value: "MMK", label: "Burmese kyat", symbol: "K" },
  { value: "BIF", label: "Burundian franc", symbol: "FBu" },
  { value: "KHR", label: "Cambodian riel", symbol: "៛" },
  { value: "CAD", label: "Canadian dollar", symbol: "$" },
  { value: "CVE", label: "Cape Verdean escudo", symbol: "$" },
  { value: "KYD", label: "Cayman Islands dollar", symbol: "$" },
  { value: "XAF", label: "Central African CFA franc", symbol: "FCFA" },
  { value: "XPF", label: "CFP franc", symbol: "₣" },
  { value: "CLP", label: "Chilean peso", symbol: "$" },
  { value: "CNY", label: "Chinese yuan", symbol: "¥" },
  { value: "COP", label: "Colombian peso", symbol: "$" },
  { value: "KMF", label: "Comorian franc", symbol: "CF" },
  { value: "CDF", label: "Congolese franc", symbol: "FC" },
  { value: "CRC", label: "Costa Rican colón", symbol: "₡" },
  { value: "HRK", label: "Croatian kuna", symbol: "kn" },
  { value: "CUC", label: "Cuban convertible peso", symbol: "$" },
  { value: "CUP", label: "Cuban peso", symbol: "$" },
  { value: "CZK", label: "Czech koruna", symbol: "Kč" },
  { value: "DKK", label: "Danish krone", symbol: "kr" },
  { value: "DOP", label: "Dominican peso", symbol: "RD$" },
  { value: "DJF", label: "Djiboutian franc", symbol: "Fdj" },
  { value: "XCD", label: "Eastern Caribbean dollar", symbol: "$" },
  { value: "EGP", label: "Egyptian pound", symbol: "£" },
  { value: "ERN", label: "Eritrean nakfa", symbol: "Nfk" },
  { value: "ETB", label: "Ethiopian birr", symbol: "Br" },
  { value: "EUR", label: "Euro", symbol: "€" },
  { value: "FKP", label: "Falkland Islands pound", symbol: "£" },
  { value: "FJD", label: "Fijian dollar", symbol: "$" },
  { value: "GMD", label: "Gambian dalasi", symbol: "D" },
  { value: "GEL", label: "Georgian lari", symbol: "₾" },
  { value: "GHS", label: "Ghanaian cedi", symbol: "₵" },
  { value: "GIP", label: "Gibraltar pound", symbol: "£" },
  { value: "GTQ", label: "Guatemalan quetzal", symbol: "Q" },
  { value: "GGP", label: "Guernsey pound", symbol: "£" },
  { value: "GNF", label: "Guinean franc", symbol: "FG" },
  { value: "GYD", label: "Guyanese dollar", symbol: "$" },
  { value: "HTG", label: "Haitian gourde", symbol: "G" },
  { value: "HNL", label: "Honduran lempira", symbol: "L" },
  { value: "HKD", label: "Hong Kong dollar", symbol: "HK$" },
  { value: "HUF", label: "Hungarian forint", symbol: "Ft" },
  { value: "ISK", label: "Icelandic króna", symbol: "kr" },
  { value: "INR", label: "Indian rupee", symbol: "₹" },
  { value: "IDR", label: "Indonesian rupiah", symbol: "Rp" },
  { value: "IRR", label: "Iranian rial", symbol: "﷼" },
  { value: "IQD", label: "Iraqi dinar", symbol: "ع.د" },
  { value: "ILS", label: "Israeli new shekel", symbol: "₪" },
  { value: "JMD", label: "Jamaican dollar", symbol: "J$" },
  { value: "JPY", label: "Japanese yen", symbol: "¥" },
  { value: "JEP", label: "Jersey pound", symbol: "£" },
  { value: "JOD", label: "Jordanian dinar", symbol: "د.ا" },
  { value: "KZT", label: "Kazakhstani tenge", symbol: "₸" },
  { value: "KES", label: "Kenyan shilling", symbol: "KSh" },
  { value: "KID", label: "Kiribati dollar", symbol: "$" },
  { value: "KGS", label: "Kyrgyzstani som", symbol: "с" },
  { value: "KWD", label: "Kuwaiti dinar", symbol: "د.ك" },
  { value: "LAK", label: "Lao kip", symbol: "₭" },
  { value: "LBP", label: "Lebanese pound", symbol: "ل.ل" },
  { value: "LSL", label: "Lesotho loti", symbol: "L" },
  { value: "LRD", label: "Liberian dollar", symbol: "$" },
  { value: "LYD", label: "Libyan dinar", symbol: "ل.د" },
  { value: "MOP", label: "Macanese pataca", symbol: "MOP$" },
  { value: "MKD", label: "Macedonian denar", symbol: "ден" },
  { value: "MGA", label: "Malagasy ariary", symbol: "Ar" },
  { value: "MWK", label: "Malawian kwacha", symbol: "MK" },
  { value: "MYR", label: "Malaysian ringgit", symbol: "RM" },
  { value: "MVR", label: "Maldivian rufiyaa", symbol: "ރ." },
  { value: "IMP", label: "Manx pound", symbol: "£" },
  { value: "MRU", label: "Mauritanian ouguiya", symbol: "UM" },
  { value: "MUR", label: "Mauritian rupee", symbol: "₨" },
  { value: "MXN", label: "Mexican peso", symbol: "$" },
  { value: "MDL", label: "Moldovan leu", symbol: "L" },
  { value: "MNT", label: "Mongolian tögrög", symbol: "₮" },
  { value: "MAD", label: "Moroccan dirham", symbol: "د.م." },
  { value: "MZN", label: "Mozambican metical", symbol: "MT" },
  { value: "NAD", label: "Namibian dollar", symbol: "$" },
  { value: "NPR", label: "Nepalese rupee", symbol: "₨" },
  { value: "ANG", label: "Netherlands Antillean guilder", symbol: "ƒ" },
  { value: "TWD", label: "New Taiwan dollar", symbol: "NT$" },
  { value: "NZD", label: "New Zealand dollar", symbol: "$" },
  { value: "NIO", label: "Nicaraguan córdoba", symbol: "C$" },
  { value: "NGN", label: "Nigerian naira", symbol: "₦" },
  { value: "KPW", label: "North Korean won", symbol: "₩" },
  { value: "NOK", label: "Norwegian krone", symbol: "kr" },
  { value: "OMR", label: "Omani rial", symbol: "ر.ع." },
  { value: "PKR", label: "Pakistani rupee", symbol: "₨" },
  { value: "PAB", label: "Panamanian balboa", symbol: "B/." },
  { value: "PGK", label: "Papua New Guinean kina", symbol: "K" },
  { value: "PYG", label: "Paraguayan guaraní", symbol: "₲" },
  { value: "PEN", label: "Peruvian sol", symbol: "S/" },
  { value: "PHP", label: "Philippine peso", symbol: "₱" },
  { value: "PLN", label: "Polish złoty", symbol: "zł" },
  { value: "QAR", label: "Qatari riyal", symbol: "ر.ق" },
  { value: "RON", label: "Romanian leu", symbol: "lei" },
  { value: "RUB", label: "Russian ruble", symbol: "₽" },
  { value: "RWF", label: "Rwandan franc", symbol: "RF" },
  { value: "SHP", label: "Saint Helena pound", symbol: "£" },
  { value: "WST", label: "Samoan tālā", symbol: "WS$" },
  { value: "STN", label: "São Tomé and Príncipe dobra", symbol: "Db" },
  { value: "SAR", label: "Saudi riyal", symbol: "ر.س" },
  { value: "RSD", label: "Serbian dinar", symbol: "дин." },
  { value: "SLL", label: "Sierra Leonean leone", symbol: "Le" },
  { value: "SGD", label: "Singapore dollar", symbol: "$" },
  { value: "SOS", label: "Somali shilling", symbol: "S" },
  { value: "SLS", label: "Somaliland shilling", symbol: "Sh" },
  { value: "ZAR", label: "South African rand", symbol: "R" },
  { value: "KRW", label: "South Korean won", symbol: "₩" },
  { value: "SSP", label: "South Sudanese pound", symbol: "£" },
  { value: "SRD", label: "Surinamese dollar", symbol: "$" },
  { value: "SEK", label: "Swedish krona", symbol: "kr" },
  { value: "CHF", label: "Swiss franc", symbol: "CHF" },
  { value: "LKR", label: "Sri Lankan rupee", symbol: "₨" },
  { value: "SZL", label: "Swazi lilangeni", symbol: "L" },
  { value: "SYP", label: "Syrian pound", symbol: "£" },
  { value: "TJS", label: "Tajikistani somoni", symbol: "ЅМ" },
  { value: "TZS", label: "Tanzanian shilling", symbol: "TSh" },
  { value: "THB", label: "Thai baht", symbol: "฿" },
  { value: "TOP", label: "Tongan paʻanga", symbol: "T$" },
  { value: "PRB", label: "Transnistrian ruble", symbol: "р." },
  { value: "TTD", label: "Trinidad and Tobago dollar", symbol: "TT$" },
  { value: "TND", label: "Tunisian dinar", symbol: "د.ت" },
  { value: "TRY", label: "Turkish lira", symbol: "₺" },
  { value: "TMT", label: "Turkmenistan manat", symbol: "T" },
  { value: "TVD", label: "Tuvaluan dollar", symbol: "$" },
  { value: "UGX", label: "Ugandan shilling", symbol: "USh" },
  { value: "UAH", label: "Ukrainian hryvnia", symbol: "₴" },
  { value: "AED", label: "United Arab Emirates dirham", symbol: "د.إ" },
  { value: "USD", label: "United States dollar", symbol: "$" },
  { value: "UYU", label: "Uruguayan peso", symbol: "$U" },
  { value: "UZS", label: "Uzbekistani soʻm", symbol: "UZS" },
  { value: "VUV", label: "Vanuatu vatu", symbol: "VT" },
  { value: "VES", label: "Venezuelan bolívar soberano", symbol: "Bs.S." },
  { value: "VND", label: "Vietnamese đồng", symbol: "₫" },
  { value: "XOF", label: "West African CFA franc", symbol: "CFA" },
  { value: "ZMW", label: "Zambian kwacha", symbol: "ZK" },
  { value: "ZWB", label: "Zimbabwean bonds", symbol: "ZWL" },
];
